import { MyTenders } from './MyTenders';
import { CabinetLayout } from '@web-kc/shared/components';

import { useTranslation } from 'next-i18next';

export function MyLotsCabinetPage() {
  const { t } = useTranslation();

  return (
    <CabinetLayout pageTitle={t('common:pageTitle.cabinet.my-lots')}>
      <MyTenders type="lots" />
    </CabinetLayout>
  );
}
